import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x8304E6187ceABc5028C7Fc990B3342fEC239Df8E', // TODO
  [ChainId.BSCTESTNET]: '0x8304E6187ceABc5028C7Fc990B3342fEC239Df8E',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
